module.exports = __webpack_public_path__ + "./img/loginBGMobile.png?f1e416d76dad2967535425af31a0098a";